// Test IDs for the Shop / catalog, product detail (PDP) and cart features.
// Values are kebab-case `<feature>-<element>`; keys are camelCase.

export const SHOP = {
  page: "shop-page",
  grid: "shop-product-grid",
  card: "shop-product-card",
  cardLink: "shop-product-card-link",
  cardAdd: "shop-product-card-add",
  sortSelect: "shop-sort-select",
  categoryFilter: "shop-filter-category",
  inStockFilter: "shop-filter-in-stock",
  priceSlider: "shop-filter-price",
  flagFilter: "shop-filter-flag",
  clearFilters: "shop-clear-filters",
  resultCount: "shop-result-count",
  empty: "shop-empty-state",
  loading: "shop-loading-state",
  error: "shop-error-state",
  retry: "shop-retry-button",
};

export const PDP = {
  page: "pdp-page",
  gallery: "pdp-gallery",
  name: "pdp-name",
  price: "pdp-price",
  mrp: "pdp-mrp",
  stock: "pdp-stock",
  variant: "pdp-variant",
  variantOption: "pdp-variant-option",
  addToCart: "pdp-add-to-cart",
  qtyInc: "pdp-qty-increment",
  qtyDec: "pdp-qty-decrement",
  qtyValue: "pdp-qty-value",
};

export const CART = {
  drawer: "cart-drawer",
  open: "cart-open-button",
  close: "cart-close-button",
  count: "cart-count-badge",
  item: "cart-line-item",
  itemRemove: "cart-item-remove",
  itemInc: "cart-item-increment",
  itemDec: "cart-item-decrement",
  itemQty: "cart-item-qty",
  subtotal: "cart-subtotal",
  checkout: "cart-checkout-button",
  empty: "cart-empty-state",
};
